<template>
  <!-- 合同范本 -->
  <div id="contractmodel">
    <div class="htfb_banner">
      <img src="../../assets/home/banner_sample_1.png" />
	  
	  <div class="box" >
	  	<div class="menulist">
	  	  <div
	  	    class="menuitem flex_start"
	  	    v-for="(item, index) in catelist"
	  	    :key="index"
	  	    :class="{ activ: index == menuactive }"
	  	    @click="tojump('/jpcol/contractmodel/hdcht')"
	  	    @mouseover="changetag(index)"
	  	  >
	  	    <div class="cover">
	  	      <img src="../../assets/jpcol/htfbmenuicon1.png" alt="" />
	  	    </div>
	  	    <div class="text">
	  	      <div class="t1">{{item.name}}</div>
	  	      <div class="t2">140000+次下载</div>
	  	    </div>
	  	    <div class="jt"><svg-icon icon-class="jt_right" /></div>
	  	  </div>
	  	  <router-link to="/jpcol/contractmodel/hdcht">
	  				<div class="mov">MORE+</div>
	  			</router-link>
	  	</div>
	  </div>
    </div>

    <section><htfbmenu /> </section>
    <section><htfbwntj /> </section>
    <!-- <section><htfbcenban /> </section> -->
    <section class="w10ff"><htfbhtjf /> </section>
    <section><htfbznrk /> </section>

  </div>
</template>

<script>

import htfbmenu from "./child/htfbmenu";
import htfbwntj from "./child/htfbwntj";
// import htfbcenban from "./child/htfbcenban";
import htfbhtjf from "./child/htfbhtjf";
import htfbznrk from "./child/htfbznrk";

export default {
  name: "contractmodel",
  components: {
  
    // 私
    htfbmenu,
    htfbwntj,
    // htfbcenban,
    htfbhtjf,
    htfbznrk,
  
  
  },
  data:() => {
	  return{
		menuactive: 0,
		catelist:[]  
	  }
  },

  created() {
  	this.$http.jpcol.getcontractify().then( res => {
  			res.data.forEach((value)=>{
  						if(value.children){
  							let arr = value.children.map(val =>{
  								return {name:val.cat_name,id:val.id}
  							})
  							
  						this.catelist =	this.catelist.concat(arr)
  						console.log(this.catelist)
  						}
  					})
  	})
  },
  methods: {
    changetag(index) {
      this.menuactive = index;
    },
    tojump(path) {
      console.log("点击了跳转", path);
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#contractmodel {
background: #F8F8F8;
  .htfb_banner{
	  position: relative;
      max-width: 1920px;
      width: 100%;
	  height: 430px;
      overflow: hidden;
      margin: 0 auto;
      img{
          width: 1920px;
      }
  }
  .w10ff{
    width: 100%;
    background-color: #fff;
  }
  
  .box{
	  position: absolute;
	  width: 1200px;
	  height: 100%;
	  margin-left: -600px;
	  left: 50%;
	  top: 0;
	  .menulist {
	    width: 205px;
	    height: 100%;
		padding-top: 28px;
	    background: #ffffff;
	    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
	  	z-index: 99;
	    .menuitem {
			margin-bottom: 28px;
	      padding-left: 20px;
	      color: #999999;
	      cursor: pointer;
	      .cover {
	        margin-right: 12px;
	        img {
	          width: 38px;
	          height: 38px;
	          border-radius: 50%;
	        }
	      }
	      .text {
	        font-size: 16px;
	        width: 105px;
	        .t1 {
	          color: #333333;
	        }
	        .t2 {
	          font-size: 13px;
	        }
	      }
	      .jt {
	        display: none;
	        font-size: 12px;
	      }
	      &.activ {
	        border-left: 4px solid #0465ea;
	        padding-left: 16px;
	        .text {
	          color: #0465ea;
	        }
	        .jt {
	          display: block;
	        }
	      }
	    }
	    .mov {
	      cursor: pointer;
	      width: 120px;
	      height: 26px;
	      line-height: 26px;
	      text-align: center;
	      margin: 30px auto 0;
	      background: #ebf2ff;
	      border-radius: 5px;
	      font-size: 14px;
	      color: #0465ea;
	    }
	  }
  }
  
}
</style>